import { MaxbrainImage } from 'app/library/image-library/models/maxbrain-image.model';
import { ICatalogListingBookingTransferQuery } from '../interfaces/catalog-listing-booking-transfer.query.interface';

export class CatalogListingBookingTransfer {
    id: string;
    listingId: number;
    name: string;
    version: string;
    image: MaxbrainImage | null;
    startDate: string | null;
    endDate: string | null;

    constructor(query: ICatalogListingBookingTransferQuery) {
        this.id = query.id.toString();
        this.listingId = query.listing_id;
        this.name = query.name;
        this.version = query.version;
        this.image = query.image ? new MaxbrainImage(query.image) : null;
        this.startDate = query.start_date ?? null;
        this.endDate = query.end_date ?? null;
    }
}
